// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1VAbS","form":"styles_form__sJw-0"};